import { useSetPageTitle } from "../../hooks/useSetPageTitle";
import { AppLayout } from "../../components/layout/app-layout";
import GeoMapperTab from "./tabs/geo-mapper.tab";
import ScreenshotterTab from "./tabs/screenshotter.tab";
import { useNavigate, useParams } from "react-router-dom";
import ToolsTab from "./tabs/tools-tab";


type ToolsTabs = '' | 'geo-mapper' | 'screenshotter';


const ToolsPage = () => {
  const navigate = useNavigate();

  const { tab } = useParams<{ tab?: string }>();

  useSetPageTitle('Tools');


  const toolTabs = [
    {
      id: '',
      key: 'tools',
      label: 'Tools',
    },
    {
      id: 'geo-mapper',
      key: 'geo-mapper',
      label: 'Geo Mapper',
    },
    {
      id: 'screenshotter',
      key: 'screenshotter',
      label: 'Screenshotter',
    },
  ];

  const validTabs = toolTabs.map(tab => tab.id);
  type TabType = typeof validTabs[number];

  const currentTab: TabType = validTabs.includes(tab as TabType)
    ? (tab as TabType)
    : '';

  const handleTabChange = (tabId: string) => {
    navigate(`/tools/${tabId}`);
  };

  return (
    <AppLayout
      activePage="/tools"
      navbarProps={{
        showBackButton: true,
        backPath: "/tools",
        tabs: toolTabs,
        activeTab: currentTab,
        onTabChange: handleTabChange,
      }}
    >
      <div className="h-[calc(100vh-8rem)] overflow-hidden">
        {currentTab === '' && <ToolsTab />}
        {currentTab === 'geo-mapper' && <GeoMapperTab />}
        {currentTab === 'screenshotter' && <ScreenshotterTab />}
      </div>
    </AppLayout>
  );
};

export default ToolsPage;